<dw-ui-panel [preventClose]="true" [defaultOpenedPanel]="profile">
  <dw-grid-detail-navigation
    header-actions
    [context]="GoliathDocumentEntityNames.DocTemplate.shortName"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul ngbNav #nav="ngbNav" class="nav-underline nav-tabs d-flex border-0 me-md-auto">
        <li [ngbNavItem]="'general'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy style="height: 70vh">
              <div class="mt-2">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  (ngSubmit)="save()"
                  class="container-panel"
                >
                  <div class="card-group header card-col mt-2 mb-3">
                    <div class="card">
                      <div class="row row-cols-md-6">
                        <div class="col col-md-2 form-check form-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="isActive"
                            formControlName="isActive"
                          />
                          <label for="isActive" class="form-check-label text-primary">
                            {{ '::IsActive' | abpLocalization }}
                          </label>
                        </div>
                      </div>

                      <div class="row row-cols-1 row-cols-md-6">
                        <div class="col col-md-2">
                          <label for="uniqueCode" class="form-label text-primary" dwInputRequired>
                            {{ '::UniqueCode' | abpLocalization }}
                          </label>
                          <input
                            class="form-control"
                            type="text"
                            id="uniqueCode"
                            formControlName="uniqueCode"
                            [DwInput]
                          />
                        </div>
                        <div class="col col-md-4">
                          <label for="name" class="form-label text-primary" dwInputRequired>
                            {{ '::Name' | abpLocalization }}
                          </label>
                          <input
                            type="text"
                            formControlName="name"
                            class="form-control"
                            [DwInput]
                          />
                        </div>
                        <div class="col col-md-2">
                          <label for="languageId" class="form-label text-primary" dwInputRequired>
                            {{ '::Language' | abpLocalization }}
                          </label>
                          <ng-select
                            class="form-control"
                            id="languageId"
                            formControlName="languageId"
                            [loading]="languageStore.loading()"
                            bindLabel="name.current"
                            bindValue="id"
                            [items]="languageStore.entities()"
                          >
                          </ng-select>
                        </div>
                        <div class="col col-md-4">
                          <label for="roles" class="form-label text-primary" dwInputRequired>
                            {{ 'Doc::DocTemplate:Roles' | abpLocalization }}
                          </label>
                          <ng-select
                            class="form-control"
                            id="roles"
                            formControlName="roles"
                            bindLabel="name.current"
                            bindValue="id"
                            [loading]="coreEnumerationTypeStore.loading()"
                            [items]="coreEnumerationTypeStore.docRoles()"
                            [multiple]="true"
                          >
                            <ng-template ng-multi-label-tmp let-items="items">
                              @for (item of items; track $index) {
                                <div class="ng-value">
                                  <span
                                    class="badge rounded-pill"
                                    [style.color]="item?.textColor ?? '#FFF'"
                                    [style.backgroundColor]="item?.backgroundColor ?? '#6c757d'"
                                  >
                                    {{ item?.name?.current ?? '' }}</span
                                  >
                                </div>
                              }
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  @if (entity?.id) {
                    <h4 ngbScrollSpyFragment="lines" dwScrollSpyItem [fragment]="'lines'">
                      {{ 'Doc::CustomerQuote:ProductsAndServices' | abpLocalization }}
                    </h4>
                    <div>
                      <document-template-lines-editor
                        [docTemplate]="entity"
                        (linesChanged)="activateSaveButton()"
                      ></document-template-lines-editor>
                    </div>
                  }
                </form>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <dw-ui-detail-header
        [saveDisabled]="form.invalid || !form.dirty"
        [saveBusy]="isSaving()"
        [shortcut]="shortcut.controlS"
      ></dw-ui-detail-header>
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>
  <div side-panel-content>
    <dw-ui-side-panel #profile [contentTemplate]="bodyProfile">
      <ng-template #bodyProfile>
        <label for="note" class="form-label text-primary mt-3">{{
          '::Note' | abpLocalization
        }}</label>
        @if (entity != null) {
          <textarea
            name="note"
            class="flex-grow-1"
            resize="none"
            [(ngModel)]="entity.note"
            (input)="updateNote($event)"
          ></textarea>
        }
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>
